import classNames from "classnames";
import Badge from "app/components/shared/Badge";

import type { BuildViewTypes } from ".";
// eslint-disable-next-line no-duplicate-imports
import { BUILD_VIEW_TYPES } from ".";

function BuildContentNavigation({
  buildPath,
  currentView,
  waterfallAvailable = false,
}: {
  buildPath: string;
  currentView: BuildViewTypes;
  waterfallAvailable?: boolean;
}) {
  const { location } = window;

  // Assemble the URLs for the different views for this build
  const buildUrl = `${location.protocol}//${location.hostname}${buildPath}`;
  const listViewHref = buildUrl;
  const waterfallHref = `${buildUrl}/waterfall`;
  const graphHref = `${buildUrl}/graph`;

  const renderUpgradeBadge = () => {
    return waterfallAvailable ? null : (
      <Badge outline={false} className="white bg-purple right">
        Upgrade
      </Badge>
    );
  };

  return (
    <nav
      className="Tablist flex mb4 border-bottom border-gray"
      data-testid="buildViewTabsNav"
    >
      <a
        className={classNames("btn btn-tab", {
          "btn-tab--active": currentView === BUILD_VIEW_TYPES.JOB_LIST,
        })}
        href={listViewHref}
      >
        Jobs
      </a>

      {window.Features.PipelineBuildGraph && (
        <a
          className={classNames("btn btn-tab", {
            "btn-tab--active": currentView === BUILD_VIEW_TYPES.GRAPH,
          })}
          href={graphHref}
        >
          Graph <Badge outline={true}>Alpha</Badge>
        </a>
      )}

      <a
        className={classNames("btn btn-tab", {
          "btn-tab--active": currentView === BUILD_VIEW_TYPES.WATERFALL,
        })}
        href={waterfallHref}
      >
        <span>Waterfall</span>
        {renderUpgradeBadge()}
      </a>
    </nav>
  );
}

export default BuildContentNavigation;
